import { UserRoleEnum } from '@core/enums/user_role_enum';

/** Roles allowed to manage alarm settings (the Settings tab gate) and, by the same rule, to
 * count as a "recipient candidate" default: a partner admin (own or installer-managed company).
 * This is the sole authorization check for alarm settings access - the backend's
 * `manage_alarm_settings` feature grant is no longer relied on. Xemex roles were removed here
 * (RDT-1018): Xemex staff must not see or edit alarm settings at all, for any partner. */
export const ALARM_ADMIN_ROLES: string[] = [
  UserRoleEnum.PartnerAdmin,
  UserRoleEnum.InstallerAdmin,
  UserRoleEnum.SubInstallerAdmin,
];
